import api from '..'

const getLesson = (lessonId: number) => {
  return api.get(`lessons/${lessonId}`).then(
    ({
      data: {
        data: { attributes },
      },
    }) => {
      return attributes
    }
  )
}

export default getLesson
